export const users = {
  title_create: "Create an users",
  table: {
    status: "Status",
    isVerified: "Verified",
    createdAt: "Created At",
  },
  form: {
    name: "Name",
    name_required: "The name is required",
    email: "Email",

    role: "Role",
    title_edit: "Update an user",

    creating: "Creating...",
    submit: "Create",
    name_placeholder: "User name",
    email_placeholder: "Email",

    role_placeholder: "Role ID",
    title: "Edit user",
    select_role: "Select a role",

    updating: "Updating...",
    update: "Update",
    create_success: "Client created successfully",
    update_success: "Client updated successfully",
    deactivate_success: "Offer deactivated successfully",
    create_error: "Error creating client",
    update_error: "Error updating client",
    deactivate_error: "Error deactivating client",
    status: "Status",
  },
  actions: {
    edit: "Edit",
    disable: "Disable",
    enable: "Enable",
    consulter: "consult",
  },
  header_title: "Users List",
};
